import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";

export interface VaultSameSourceTransactionsDialogData {
  srIdLabel: string;
  transactions: TransactionView[];
}

@Component({
  selector: "app-vault-same-source-transactions-dialog",
  standalone: true,
  imports: [GlossScrollDirective, MatDialogModule, MatButtonModule],
  templateUrl: "./vault-same-source-transactions-dialog.component.html",
})
export class VaultSameSourceTransactionsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: VaultSameSourceTransactionsDialogData) {}

  txJson(tx: TransactionView): string {
    try {
      return JSON.stringify(tx.toStoreModel(), null, 2);
    } catch {
      return String(tx.id);
    }
  }
}
